import React from 'react';
import { Link } from 'react-router-dom';
import work3 from '../../../assets/p3.png'
const Project3 = () => {
    const projectsData =
    {
        id: 1,
        image: work3,
        title: "BuySellRepeat",
        description: "Full-Stack MERN Projects",
        link: "https://assignment-12-9aa5e.web.app/",
        go: "/project1"
    };
    return (
        <div className='mt-[70px]'>

            <h1 className='text-center text-5xl font-bold mb-10'>Welcome to my project</h1>
            <div className=''>
                <img className='w-1/2 mx-auto' src={projectsData.image} alt="" />
            </div>
            <div className='w-1/2 mx-auto mt-10 flex justify-between'>
                <Link to='/project2' className='btn btn-warning'>Previous project</Link>
                <Link to='/project1' className='btn btn-warning'>Next project</Link>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2 className='text-3xl text-info'>EdTech- a online Learning website for tech related Courses </h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2>Built with: React, Tailwind, Express, NodeJS, MongoDB.</h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2>Feature included: Firebase Authentication, Private route,react-router, CRUD operation, Service page, react-to-pdf, course details/overview, FAQ, Blog page, vercel for server deploy. </h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <h2>Key Features:
                    <br />
                    1. This web site contains various courses of computer Science field. Here you can Learn about those course in details with course plan and requirements.
                    <br /><br />
                    2. Here anyone can visit our site check our courses without login, they can see our course outline,timeline,topics they will learn, how much time they will need to complete the course and what kind of skill they will gain from visiting the site.
                    <br /><br />
                    3.User can sign up by using their email, name and photo url or they can easily use their gmail and github account to easily log in to the site.
                </h2>
            </div>
            <div className='w-1/2 mx-auto mt-10'>
                <a className='button' target='_blank' rel="noopener noreferrer" href="https://github.com/RAZYANIK/Ed-tech-client-repo">Client site Git Link</a>
                <a className='button ml-10' href="https://github.com/RAZYANIK/edTech-server-site-repo" target='_blank' rel="noopener noreferrer">Server site Git Link</a>
            </div>
        </div>
    );
};

export default Project3;